(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollReveal() {
    var targets = document.querySelectorAll('.brew-reveal, .brew-reveal-group');
    if (!targets.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initMeasuringSachet() {
    var roots = document.querySelectorAll('[data-brewrage-measure]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var fill = root.querySelector('[data-measure-fill]');
      var toggles = root.querySelectorAll('[data-measure-dose]');
      var levels = {
        strong: root.dataset.strongLevel,
        regular: root.dataset.regularLevel,
      };

      function setDose(dose) {
        var level = levels[dose];
        if (fill && level) {
          fill.style.setProperty('--fill-level', level);
        }
        toggles.forEach(function (btn) {
          var active = btn.dataset.measureDose === dose;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      toggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setDose(btn.dataset.measureDose);
        });
      });

      if (reduceMotion || !('IntersectionObserver' in window)) {
        root.classList.add('is-filled');
        setDose('regular');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-filled');
              setDose('regular');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.45 }
      );
      observer.observe(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initMeasuringSachet();
  });
})();
